import { render, staticRenderFns } from "./DropoffPanel.vue?vue&type=template&id=5e80d04c&"
import script from "./DropoffPanel.vue?vue&type=script&lang=js&"
export * from "./DropoffPanel.vue?vue&type=script&lang=js&"
import style0 from "./DropoffPanel.vue?vue&type=style&index=0&id=5e80d04c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports